/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputUavMissionTemplate
 */
export interface InputUavMissionTemplate {
    /**
     * 
     * @type {string}
     * @memberof InputUavMissionTemplate
     */
    name: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof InputUavMissionTemplate
     */
    payload?: { [key: string]: object; };
}

/**
 * Check if a given object implements the InputUavMissionTemplate interface.
 */
export function instanceOfInputUavMissionTemplate(value: object): boolean {
    if (!('name' in value)) return false;
    return true;
}

export function InputUavMissionTemplateFromJSON(json: any): InputUavMissionTemplate {
    return InputUavMissionTemplateFromJSONTyped(json, false);
}

export function InputUavMissionTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUavMissionTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'payload': json['payload'] == null ? undefined : json['payload'],
    };
}

export function InputUavMissionTemplateToJSON(value?: InputUavMissionTemplate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'payload': value['payload'],
    };
}

